module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dtf2v"))).then(() => parcelRequire('2KbAe'));